import React from 'react';
import { Card, Typography } from 'antd';
import './IconCard.css';

const { Title, Paragraph } = Typography;

const IconCard = ({ variant = 'light', title, description, icon }) => (
  <Card className={`icon-card icon-card--${variant}`}>
    <div className="icon-card__top">
      <span className="icon-card__icon">
        { icon }
      </span>
      <Title level={3} className="icon-card__title">
        {title}
      </Title>
    </div>
    <Paragraph className="icon-card__text">{description}</Paragraph>
  </Card>
);

export default IconCard;
